// components/industry-templates/HealthcareEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity, Award, BookOpen, Users } from 'lucide-react';

export const HealthcareEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* CME Credits */}
      {industryData?.cme_credits && (
        <Card className="border-2" style={{ borderColor: theme.primary, backgroundColor: 'rgba(20, 184, 166, 0.1)' }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Award className="w-6 h-6" style={{ color: theme.primary }} />
              CME Credits Available
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center p-4 bg-white/5 rounded-lg">
                <p className="text-3xl font-bold" style={{ color: theme.primary }}>{industryData.cme_credits.hours}</p>
                <p className="text-sm text-slate-400">Hours</p>
              </div>
              <div className="col-span-2 flex items-center">
                <p className="text-white">Accredited by <span className="font-bold" style={{ color: theme.primary }}>{industryData.cme_credits.accredited_by}</span></p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Specializations */}
      {industryData?.specializations && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Activity className="w-6 h-6" style={{ color: theme.primary }} />
              Medical Specializations
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2">
              {industryData.specializations.map((spec: string, idx: number) => (
                <Badge key={idx} style={{ backgroundColor: theme.primary }} className="text-white text-sm py-2 px-4">
                  {spec}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Speakers */}
      {industryData?.speakers && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Users className="w-6 h-6" style={{ color: theme.primary }} />
              Expert Speakers
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.speakers.map((speaker: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border border-white/10">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center text-xl" style={{ backgroundColor: theme.primary }}>
                      ⚕️
                    </div>
                    <div className="flex-1">
                      <h4 className="font-bold text-white">{speaker.name}</h4>
                      <p className="text-sm text-slate-400">{speaker.credentials}</p>
                      <p className="text-sm" style={{ color: theme.primary }}>{speaker.specialty}</p>
                      {speaker.topic && <p className="text-xs text-slate-500 mt-2">Topic: {speaker.topic}</p>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Case Studies */}
      {industryData?.case_studies && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <BookOpen className="w-6 h-6" style={{ color: theme.primary }} />
              Case Studies & Research
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/5 rounded-lg p-4">
              <p className="text-white"><span className="font-bold" style={{ color: theme.primary }}>{industryData.case_study_sessions}</span> Case Study Sessions</p>
              {industryData.research_papers && (
                <p className="text-slate-400 mt-2">Research paper submissions accepted • Best paper award available</p>
              )}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
